import { createContext, useContext, useRef } from 'react';
import { create } from 'zustand';

const createStore = () => {
  return create<{
    isFormDirty: boolean;
    isClosing: boolean;
    isBound: boolean;
    setIsClosing: (isClosing: boolean) => void;
    setIsFormDirty: (isFormDirty: boolean) => void;
    setIsBound: (isBound: boolean) => void;
  }>((set) => ({
    isFormDirty: false,
    isBound: false,
    isClosing: false,
    setIsFormDirty: (isFormDirty) => set({ isFormDirty }),
    setIsClosing: (isClosing) => set({ isClosing }),
    setIsBound: (isBound) => set({ isBound }),
  }));
};

export type FormGuardStore = ReturnType<typeof createStore>;

const context = createContext<FormGuardStore | null>(null);

export const useFormGuardContext = () => {
  const store = useContext(context);

  return store;
};

export const FormGuardProvider = ({
  children,
}: { children: React.ReactNode }) => {
  const storeRef = useRef<ReturnType<typeof createStore>>();

  if (!storeRef.current) {
    storeRef.current = createStore();
  }

  return (
    <context.Provider value={storeRef.current}>{children}</context.Provider>
  );
};
